module.exports = __webpack_public_path__ + "img/2-4.73155a0f.svg";